import { render, staticRenderFns } from "./CareProtocol.vue?vue&type=template&id=4b3f4633&"
import script from "./CareProtocol.vue?vue&type=script&lang=js&"
export * from "./CareProtocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports